export const ExtendInputOptions = {
    fullWidth: true,
};

export const DisabledExtendSelectOptions = {
    ...ExtendInputOptions,
    disabled: true,
    inputStyle: {
        color: 'black'
    },
    labelStyle: {
        color: 'black'
    },
};

export const DisabledExtendInputOptions = {
    ...ExtendInputOptions,
    disabled: true,
    inputStyle: {
        color: 'black'
    },
};

export const SubsPlanChoices = [
    { id: 'DECADE', name: 'Premium 10 Years' },
];

export const SubsPaymentChoices = [
    { id: 1, name: 'Free' },
    { id: 2, name: 'Cash Collection' },
    { id: 3, name: 'AirPay' },
    { id: 4, name: 'Bank Transfer' },
];


const FreeTrialStatusNA = 0;
const FreeTrialStatusNormal = 1;
const FreeTrialStatusOverdue = 2;

export const FreeTrialStatusChoices = {
    [FreeTrialStatusNA]:'',    
    [FreeTrialStatusNormal]: 'Normal',
    [FreeTrialStatusOverdue]: 'Overdue'
};


// WEBPACK FOOTER //
// ./src/routes/subscription/utils.js